
function createModal(options) {
    // Imposto i valori di default destrutturando l'oggetto
    const {
        header = '',
        body = '',
        cancel_label = 'Annulla',
        confirm_label = 'Conferma',
        cancel_callback,
        confirm_callback,
        loading = false,
        loading_label = 'Attendere...'
    } = options;


    return `
        <div id="dynamic-modal" class="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999] p-2">
            <div class="bg-white rounded-2xl shadow-xl w-full max-w-lg relative">
                <button
                    id="modal-close-button"
                    class="absolute top-4 right-4 size-10 flex items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200 transition"
                    type="button"
                >
                    <img src="/themes/custom/adoption_management/assets/icons/close-black.svg" class="size-5" alt="Chiudi">
                </button>
                <div class="px-8 pt-10 pb-6 mt-10">
                    ${header ? `<h2 class="text-xl md:text-2xl font-semibold mb-4">${header}</h2>` : ''}
                    ${body ? `<p>${body}</p>` : ''}
                </div>
                <div class="border-t border-neutral p-4 flex justify-between">
                    <button
                        id="modal-cancel-button"
                        class="bg-white border border-neutral-500 rounded-lg font-semibold text-sm py-3 px-6 hover:bg-neutral-100 transition"
                        type="button"
                    >
                        ${cancel_label}
                    </button>
                    <button
                        id="modal-confirm-button"
                        class="bg-[#dc2626] text-white rounded-lg font-semibold text-sm py-3 px-6 hover:bg-red-700 transition-colors flex items-center gap-2"
                        type="button"
                    >
                        <span class="loader-history hidden"></span>
                        <span class="confirm-label text-nowrap">${confirm_label}</span>
                    </button>
                </div>
            </div>
        </div>`;
}

//riferimento alla modale e all'abort controller per gestione dell'annulla in caso di chiamata in corso
let modalElement = null;
let currentAbortController = null;

export function openModal(options) {
    //se aperta la chiudo prima di aprirne una nuova
    if (modalElement) {
        closeModal();
    }

    //recupero le funzioni di callback
    const { confirm_callback, cancel_callback, loading, loading_label, confirm_label } = options;

    const modal = createModal(options);
    
    //creo un contenitore temporaneo per agganciare la modale al DOM
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = modal;

    modalElement = tempContainer.children[0];
    if (!modalElement) {
    console.error("Errore: Impossibile creare la modale.");
    return;
    }

    //appendo la modale al body
    document.body.appendChild(modalElement);

    // Listener per i vari pulsanti
    const confirmButton = modalElement.querySelector('#modal-confirm-button');
    const cancelButton = modalElement.querySelector('#modal-cancel-button');
    const closeButton = modalElement.querySelector('#modal-close-button');

    // Listener per il pulsante Conferma
    if (confirm_callback) {
        if (loading) {
            confirmButton.addEventListener('click',async () => {
                //creo abort controller per questa operazione
                currentAbortController = new AbortController();
                //start del loading
                setModalLoading(true , loading_label)
                try {
                    await confirm_callback(currentAbortController.signal);
                    closeModal();
                } catch (error) {
                    // Se l'errore è dovuto all'abort
                    if (error.name === 'AbortError') {
                        console.log('Operazione annullata dall\'utente');
                    } else {
                        console.error('Errore durante l\'operazione:', error);
                        setModalLoading(false, confirm_label);
                    }
                } finally {
                    currentAbortController = null;
                }    
            });
        } else {
            confirmButton.addEventListener('click', () => {
                confirm_callback();
                closeModal();
            });
        }
    }

    // Listener per i pulsanti Annulla e Chiudi
    const handleCancel = () => {
        //se ho l'operazione in corso la annullo
        if (currentAbortController) {
            currentAbortController.abort();
            currentAbortController = null;
        }

        if (cancel_callback) {
            cancel_callback();
        }
        closeModal();
    };

    cancelButton.addEventListener('click', handleCancel);
    closeButton.addEventListener('click', handleCancel);

    // Listener per il tasto Esc
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalElement) {
            handleCancel();
        }
    }, { once: true });
}

//chiude la modale
export function closeModal() {
     //annulla eventuali operazioni in corso
    if (currentAbortController) {
        currentAbortController.abort();
        currentAbortController = null;
    }

    if (modalElement && document.body.contains(modalElement)) {
        document.body.removeChild(modalElement);
        modalElement = null;
    }
}

//gestione del loading 
function setModalLoading(isLoading, label) {
  const $confirmBtn = jQuery('#modal-confirm-button');
  const $loader = $confirmBtn.find('.loader-history');
  const $labelSpan = $confirmBtn.find('.confirm-label');
  
  if (isLoading) {
    $loader.removeClass('hidden');
    $labelSpan.text(label).addClass('text-sm');
    $confirmBtn.attr('disabled', true).removeClass('bg-[#dc2626] hover:bg-red-700 text-white').addClass('opacity-75 cursor-not-allowed bg-[#F5F6F6]');
  } else {
    $loader.addClass('hidden');
    $labelSpan.text(label).removeClass('text-sm');
    $confirmBtn.attr('disabled', false).removeClass('opacity-75 cursor-not-allowed bg-[#F5F6F6]').addClass('bg-[#dc2626] hover:bg-red-700 text-white');
  }
}